import Vue from 'vue'
import Router from 'vue-router'
import store from '../base/store'

const _import = pagePath => () => import(`../view/${pagePath}`)
Vue.use(Router)

function path(path) {
  // return path+".html";
  return path;
}

const router = new Router({
  routes: [
    // 登录
    {
      path: '/admin',
      name: 'admin',
      component: _import('admin'),
      meta: {
        'title': '登录'
      },
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('verifyData_userid') > 0) {
          return next(path('/main/system/companyUser'))
        }
        next()
      }
    },
    {
      path: '/main',
      component: _import('main'),
      children: [
        {
          path: path('index'),
          name: 'index',
          component: _import('index'),
          meta: {'title': '宝藏神探'},
          beforeEnter: (to, from, next) => {
            store.commit('changeMenu', 'index')
            store.commit('changeCategoryId', 0)
            next()
          },
        },

        {
          path: 'system',
          name: 'system',
          component: _import('system/home'),
          children: [
            {
              path: path('companyUser'),
              name: 'user',
              component: _import('system/companyUser'),
              meta: {'title': '用户列表'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'user')
                next()
              },
            },
            {
              path: path('companyJigou'),
              name: 'companyJigou',
              component: _import('system/companyJigou'),
              meta: {'title': '组织机构'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'companyJigou')
                next()
              },
            },
            {
              path: path('companyRole'),
              name: 'companyRole',
              component: _import('system/companyRole'),
              meta: {'title': '角色列表'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'companyRole')
                next()
              },
            },
            {
              path: path('companyRoleNav'),
              name: 'companyRoleNav',
              component: _import('system/companyRoleNav'),
              meta: {'title': '角色列表'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'companyRoleNav')
                next()
              },
            },
            {
              path: path('basicSetting'),
              name: 'set',
              component: _import('system/BasicSetting'),
              meta: {'title': '基本设置'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'set')
                next()
              },
            },
            {
              path: path('peizhiSet'),
              name: 'peizhiSet',
              component: _import('system/peizhiSet'),
              meta: {'title': '配置设置'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'peizhiSet')
                next()
              },
            },
          ],
        },
        // 会员管理模块
        {
          path: 'member',
          name: 'Member',
          component: _import('member/home'),
          children: [
            {
              path: 'list',
              name: 'MemberList',
              component: _import('member/MemberList'),
              meta: {title: '会员列表'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'MemberList')
                next()
              },
            },
            {
              path: 'level',
              name: 'MemberLevel',
              component: _import('member/MemberLevel'),
              meta: {title: '会员卡级'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'MemberLevel')
                next()
              },
            },
            {
              path: 'detail',
              name: 'MemberDetail',
              component: _import('member/MemberDetail'),
              meta: {title: '会员详情'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'MemberDetail')
                next()
              },
            }
          ]
        },
        // 任务管理模块
        {
          path: 'task',
          name: 'Task',
          component: _import('task/home'),
          children: [
            {
              path: 'list',
              name: 'TaskList',
              component: _import('task/TaskList'),
              meta: {title: '任务列表页面', keepAlive: true},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'TaskList')
                next()
              },
            },
            {
              path: 'teskDetail',
              name: 'TaskDetail',
              component: _import('task/TaskDetail'),
              meta: {title: '任务明细页面'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'TaskDetail')
                next()
              },
            },
            {
              path: 'category',
              name: 'taskCategoryList',
              component: _import('task/taskCategoryList'),
              meta: {title: '任务分类页面'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'taskCategoryList')
                next()
              },
            },
          ]
        },
        // 拍照鉴定模块
        {
          path: 'identify',
          name: 'Identify',
          component: _import('identify/home'),
          children: [
            {
              path: 'record',
              name: 'MemberIdentifyRecord',
              component: _import('identify/MemberIdentifyRecord'),
              meta: {title: '拍照鉴定记录'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'MemberIdentifyRecord')
                next()
              },
            }
          ]
        },
        // 新增：验证码管理模块
        {
          path: 'verify',
          name: 'Verify',
          component: _import('verify/home'),
          children: [
            {
              path: 'list',
              name: 'VerifyCodeList',
              component: _import('verify/VerifyCodeList'),
              meta: {title: '验证码列表'},
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'VerifyCodeList')
                next()
              },
            },
          ]
        }
      ]
    },

  ]
})

router.onError(error => {
  console.warn(error, error.message);
  let pattern = /Loading chunk(\d)+ failed/g;
  let isChunkLoadFailed = pattern.test(error.message);
  let targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    // router.replace(targetPath);
    location.reload();
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js